
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();

import  ButtonVue from "@/lib/Button.vue";
@Component( {
      name: 'CostVue',
      components: { CostVue, ButtonVue } 
})
export default class CostVue extends Vue {
  @Prop(Object) obj:any;


  key:number=0;
  show=0;

  async mounted() { this.key++} 

  chg() {
    if (!(this.show==1)) this.show=1;
    else this.show=0;
    console.log('this.show',this.show)
    this.key++
  }

}
